'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface Alert {
  id: string;
  severity: 'high' | 'medium' | 'low';
  message: string;
  bvo: string;
  time: string;
}

const alerts: Alert[] = [
  {
    id: 'alert-001',
    severity: 'high',
    message: 'Customer Order BVO health dropped below 50',
    bvo: 'Customer Order',
    time: '8 min ago',
  },
  {
    id: 'alert-002',
    severity: 'high',
    message: 'Working Capital value-at-risk exceeded $8M threshold',
    bvo: 'Working Capital',
    time: '23 min ago',
  },
  {
    id: 'alert-003',
    severity: 'medium',
    message: 'Cash Application conformance fell to 74% (threshold: 80%)',
    bvo: 'Cash Application',
    time: '1h ago',
  },
  {
    id: 'alert-004',
    severity: 'medium',
    message: 'Fulfillment cycle time P95 exceeded 5.2 days SLA',
    bvo: 'Customer Order',
    time: '2h ago',
  },
];

const severityConfig = {
  high: { color: 'text-negative', bg: 'bg-negative/10', icon: 'ExclamationCircleIcon' },
  medium: { color: 'text-warning', bg: 'bg-warning/10', icon: 'ExclamationTriangleIcon' },
  low: { color: 'text-primary', bg: 'bg-primary/10', icon: 'InformationCircleIcon' },
};

export default function AlertsFeed() {
  return (
    <div className="bg-card rounded-xl card-glow-danger overflow-hidden">
      <div className="flex items-center justify-between px-5 py-4 border-b border-border">
        <div className="flex items-center gap-2">
          <h2 className="text-sm font-semibold text-foreground">Active Alerts</h2>
          <span className="bg-negative/20 text-negative text-2xs font-semibold px-2 py-0.5 rounded-full">
            {alerts.length}
          </span>
        </div>
        <button className="text-xs text-muted-foreground hover:text-foreground transition-colors">
          View all
        </button>
      </div>
      <div className="divide-y divide-border">
        {alerts.map((alert) => {
          const cfg = severityConfig[alert.severity];
          return (
            <div key={alert.id} className="px-5 py-3 hover:bg-muted/20 transition-colors">
              <div className="flex items-start gap-3">
                <div className={`p-1.5 rounded-lg ${cfg.bg} shrink-0 mt-0.5`}>
                  <Icon name={cfg.icon as Parameters<typeof Icon>[0]['name']} size={12} className={cfg.color} />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-xs text-foreground leading-relaxed">{alert.message}</p>
                  <div className="flex items-center gap-2 mt-1">
                    <span className="text-2xs text-primary bg-primary/10 px-1.5 py-0.5 rounded">{alert.bvo}</span>
                    <span className="text-2xs text-muted-foreground">{alert.time}</span>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}